<template>
  <div>
    <Banner />
    <section class="cards">
      <div class="card">
        <img src="@/assets/about/p-1010283@2x.png">
        <div>
          <h3>激活码</h3>
          <form
            @submit.prevent="submitRedeemForm()"
          >
            <div class="mb-3">
              <p
                v-if="hasError !== ''"
                class="text-red-500"
              >
                {{ hasError }}
              </p>
              <p
                v-else-if="redeemMsg !== ''"
                class="text-green-200"
              >
                {{ redeemMsg }}
              </p>
              <br v-else>
            </div>
            <input
              v-model="code"
              class="w-full mb-3 h-12 px-5 border text-black font-mono text-lg"
              type="text"
              name="code"
              placeholder="激活码"
              :class="{'border-red': hasError !== ''}"
              required
              @click.prevent="resetRedeemForm()"
            >
            <button
              type="submit"
              class="w-full mb-3"
              :disabled="false"
            >
              激活
            </button>
          </form>
        </div>
      </div>
    </section>
    <footer-common />
  </div>
</template>

<script>
import _ from 'lodash'
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'
import axios from 'axios'
import { NEW_API_URL } from '@/urls'

export default {
  name: 'Redeem',
  components: { Banner, FooterCommon },
  data () {
    return {
      hasError: '',
      redeemMsg: '',
      code: ''
    }
  },
  computed: {},
  mounted: function () {},
  methods: {
    resetRedeemForm () {
      this.hasError = ''
      this.redeemMsg = ''
      this.code = ''
    },
    async submitRedeemForm () {
      const requestPayLoad = {}
      const token = window.localStorage.getItem('PG_TOKEN')

      if (this.code === '') {
        this.hasError = '不合法的兑换码'
        return
      } else if (!token) {
        this.hasError = '请先登入帐号'
        return
      } else {
        requestPayLoad.code = this.code
      }
      try {
        const respData = await axios.post(
          `${NEW_API_URL}/v2/apply_redeem_code`,
          JSON.stringify(requestPayLoad), {
            headers: {
              Authorization: `JWT ${token}`,
              'Content-Type': 'application/json'
            }
          })
        console.log('Success!!', respData)
        this.hasError = ''
        this.redeemMsg = `${respData.data.item.display_name} 已经加到您的帐号`
      } catch (err) {
        if (_.has(err, 'response.data.code')) {
          switch (err.response.data.code) {
            case 'CANNOT_FIND_REDEEM':
              this.hasError = '这个激活码不存在'
              break
            case 'INVALID_PAYLOAD':
            case 'INVALID_REDEEM':
              this.hasError = '此为不合法的激活码'
              break
            case 'ALREADY_OWNED_LICENSE':
              this.hasError = '您已经拥有该软件'
              break
            default:
              this.hasError = '系统错误'
          }
        } else {
          this.hasError = '系统错误'
        }
      }
    }
  }
}
</script>

<style scoped>
section.hero > img {
  max-height: 440px;
  background-size: cover;
  width: 100%;
}
section.hero > div {
  text-align: center;
  background-image: linear-gradient(266deg, #111111, #0d0d0d);
  padding: 40px;
  line-height: 29px;
}
section.hero > div > h3 {
  margin: 0;
}

.cards {
  margin: 0 auto;
}

.card {
  display: flex;
  margin: 150px 0;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  line-height: 29px;
}
.card > img {
  flex: 1;
  max-height: 400px;
  max-width: 469px;
}
.card > div {
  max-width: 469px;
  flex: 1;
  padding-left: 50px;
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.card > div > h3 {
  color: white;
  font-weight: 300;
}

@media screen and (max-width: 768px) {
  .card {
    font-weight: 300;
    line-height: 29px;
    display: flex;
    flex-direction: column;
  }
  .card > img {
    max-width: 100%;
    margin-bottom: 30px;
  }
  .card > div {
    max-width: unset;
    flex: 1;
    padding: 0 10px;
    width: calc(100% - 20px);
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
  .card > div > h3 {
    color: white;
    font-weight: 300;
    margin: 10px 0;
  }
  .card > div > p {
    font-size: 1.2rem;
  }
  .card > form > button {
    font-size: 1.8rem;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/redeem.vue